// extracted by mini-css-extract-plugin
export default {"container":"Projekte_container__+JqNC","projectsWrapper":"Projekte_projectsWrapper__tO3+h"};